import { makeObservable } from "mobx";
import { ViewModelBase } from "@shoothill/core";
import { APIClient, RelayCommand } from "Application";
import { StagesModel, StagesModelValidator } from "./StagesModel";

export class StagesViewModel extends ViewModelBase<StagesModel> {
    public apiClient = new APIClient();

    constructor(model = new StagesModel()) {
        super(model);
        this.setValidator(new StagesModelValidator());
        makeObservable(this, {});
    }

    //#region Update Commands
    public updateStatusCommand = new RelayCommand((value: string) => {
        this.setValue("status", value);
    });
    public updateTitleCommand = new RelayCommand((value: string) => {
        this.setValue("title", value);
    });
    public updateUpdateddateCommand = new RelayCommand((value: string) => {
        this.setValue("stageDate", value);
    });
    public updateDescriptionCommand = new RelayCommand((value: string) => {
        this.setValue("description", value);
    });

    //#endregion Commands
}
